export default __webpack_public_path__ + "static/media/game-categories-active.406ea500.svg";